export const ERROR_TYPES = {
  BAD_USER_INPUT: 'BAD_USER_INPUT',
  NOT_FOUND: 'NOT_FOUND',
  UNAUTHORIZED: 'UNAUTHORIZED',
  UNEXPECTED: 'UNEXPECTED',
  UNEXPECTED_VALIDATION_ERROR: 'UNEXPECTED_VALIDATION_ERROR',
};
